// src/pages/ForgotPassword.js (Client)

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";

import passwordImage from "../assets/password.jpg";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleForgotPassword = async () => {
    if (!email) {
      setErrorMessage("Email is required.");
      setSuccessMessage("");
      return;
    }

    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/forgot-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        setSuccessMessage(
          "Password reset instructions have been sent to your email."
        );
        setErrorMessage("");
      } else {
        const errorData = await response.json().catch(() => ({}));
        setErrorMessage(errorData.error || "Unable to process your request.");
        setSuccessMessage("");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      setErrorMessage("An unexpected error occurred. Please try again later.");
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!loading) {
      handleForgotPassword();
    }
  };

  return (
    <div className="forgot-password-container">
      {/* 🔵 Gradient circular hero badge wrapper */}
      <div className="forgot-password-hero-badge-wrapper">
        <img
          src={passwordImage}
          alt="Forgot Password"
          className="forgot-password-hero-img"
        />
      </div>

      <h1>Forgot Password</h1>
      <p>
        Enter your email below, we&apos;ll send you instructions to reset your
        password.
      </p>

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
          autoComplete="email"
          aria-label="Email"
        />

        {/* ⭐ Shimmer-enabled reset button (uses .shimmer-button) */}
        <button
          type="submit"
          className="reset-btn shimmer-button"
          disabled={loading}
        >
          {loading ? "Processing..." : "Send Reset Instructions"}
        </button>
      </form>

      {/* ✅ NEW: Pill-style messages (matches Integrations look) */}
      {successMessage && (
        <div className="auth-inline-message is-success">{successMessage}</div>
      )}
      {errorMessage && (
        <div className="auth-inline-message is-error">{errorMessage}</div>
      )}

      {/* Back to login — pure text link styling via CSS */}
      <button
        className="back-to-login"
        type="button"
        onClick={() => navigate("/login")}
      >
        Back to Login
      </button>
    </div>
  );
};

export default ForgotPassword;
